module.exports = __webpack_public_path__ + "img/map_button_arrow_down.69e8566e.svg";